module.exports = __webpack_public_path__ + "img/3spades.bcdf0b27.jpg";